import type React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import './AboutUs.css';

const AboutUs: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="about-page">
      <div className="bg-accent-shape" />
      <Header />

      <main className="about-main">
        <section className="about-hero">
          <div className="about-hero-content">
            <div className="hero-line" />
            <h2 className="hero-label">{t('about.heroLabel', 'Who We Are')}</h2>
            <div className="hero-line" />
          </div>
          <h1 className="hero-title">{t('about.title', 'About Us')}</h1>
        </section>

        <section className="about-content">
          <div className="about-section">
            <h2>{t('about.mission.title', 'Our Mission')}</h2>
            <p>{t('about.mission.content')}</p>
          </div>

          <div className="about-section">
            <h2>{t('about.why.title', 'Why Was This Project Needed?')}</h2>
            <p>{t('about.why.content')}</p>
          </div>

          <div className="about-section">
            <h2>{t('about.difference.title', 'What Sets This Project Apart?')}</h2>
            <p>{t('about.difference.content')}</p>
          </div>

          <div className="about-section">
            <h2>{t('about.companions.title', 'Which Companions Are Featured?')}</h2>
            <p>{t('about.companions.content')}</p>
          </div>

          <div className="about-section">
            <h2>{t('about.methodology.title', 'Our Methodology')}</h2>
            <p>{t('about.methodology.content')}</p>
          </div>

          <div className="about-section">
            <h2>{t('about.ethics.title', 'Our Ethical Boundaries')}</h2>
            <p>{t('about.ethics.content')}</p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;
